export default {"src":"/uk/_next/static/media/play.8764c105.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};